import { array, string } from 'fp-ts';
import { useMemo } from 'react';
import { pipe } from 'fp-ts/function';
import { GuestInHouseReportReservationsDisplayOptions } from '@mews-commander/data-access';
import { ReservationsTableColumns } from '../../common';

const mapColumnsToDisplayOptions = (
    options: ReservationsTableColumns[]
): GuestInHouseReportReservationsDisplayOptions[] =>
    pipe(
        options,
        array.map((option: ReservationsTableColumns) => {
            switch (option) {
                case ReservationsTableColumns.Loyalty:
                case ReservationsTableColumns.CompanionLoyalty:
                    return [GuestInHouseReportReservationsDisplayOptions.Loyalty];
                case ReservationsTableColumns.Classifications:
                case ReservationsTableColumns.CompanionClassifications:
                    return [GuestInHouseReportReservationsDisplayOptions.Classifications];
                case ReservationsTableColumns.Products:
                    return [GuestInHouseReportReservationsDisplayOptions.AllProducts];
                case ReservationsTableColumns.Notes:
                    return [
                        GuestInHouseReportReservationsDisplayOptions.ReservationNotes,
                        GuestInHouseReportReservationsDisplayOptions.CustomerNotes,
                    ];
                case ReservationsTableColumns.CarRegistrationNumber:
                    return [GuestInHouseReportReservationsDisplayOptions.CarRegistrationNumber];
                case ReservationsTableColumns.Preauthorizations:
                case ReservationsTableColumns.Balance:
                    return [GuestInHouseReportReservationsDisplayOptions.Balance];
                case ReservationsTableColumns.VerificationPhoto:
                    return [GuestInHouseReportReservationsDisplayOptions.VerificationPhoto];
                default:
                    return [];
            }
        }),
        array.flatten,
        array.uniq(string.Eq)
    ) as GuestInHouseReportReservationsDisplayOptions[];

export const useDisplayOptions = (options: ReservationsTableColumns[], filterProductsInInterval: boolean) =>
    useMemo(
        () =>
            pipe(options, mapColumnsToDisplayOptions, (displayOptions) =>
                filterProductsInInterval
                    ? [...displayOptions, GuestInHouseReportReservationsDisplayOptions.ProductsConsumedInInterval]
                    : displayOptions
            ),
        [options, filterProductsInInterval]
    );
